module.exports = __webpack_public_path__ + "img/error.12e4f5a0.png";